"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEYCODE = void 0;
exports.getNumberWithOutUnit = getNumberWithOutUnit;
exports.getNumberWithUnit = getNumberWithUnit;
exports.getSaftyArray = getSaftyArray;
exports.isEmpty = isEmpty;
exports.isEmptyArray = isEmptyArray;
exports.noop = noop;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof = require("./typeof");
function noop() {}
var KEYCODE = exports.KEYCODE = {
  ESCAPE: 27,
  ENTER: 13,
  DELETE: 8,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  SPACE: 32
};
/**
 * 对数组做保护, 不考虑类数组
 */
function getSaftyArray(array) {
  if (!Array.isArray(array)) return [];
  return array;
}
/**
 * 获取带有单位的数据，默认为 px
 * @param {string|number} source
 */
function getNumberWithUnit(source) {
  if (!source || (0, _typeof.isBoolean)(source)) return null;
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(+source)) return source;
  return +source;
}
function getNumberWithOutUnit(source) {
  if ((0, _typeof.isNumber)(source)) return {
    value: source,
    unit: ''
  };
  var _slice = (source.toString().match(/(\d*)([^\d]*)/) || []).slice(1),
    _slice2 = (0, _slicedToArray2.default)(_slice, 2),
    value = _slice2[0],
    unit = _slice2[1];
  return {
    value: +value,
    unit: unit
  };
}
function isEmptyArray(array) {
  return getSaftyArray(array).length === 0;
}
function isEmpty(value) {
  if ((0, _typeof.isNumber)(value) || (0, _typeof.isBoolean)(value)) return false;
  if (Array.isArray(value)) return isEmptyArray(value);
  if ((0, _typeof.isObject)(value)) return isEmptyArray(Object.keys(value));
  return !value;
}